<template>
  <v-switch
    v-model="FLAG_EXIBIR_APENAS_COMBINACOES_COMPUTED"
    hide-details
    dense
    color="#A51B32"
    class="mr-3"
  >
    <template #label>
      <span class="ml-1 font-12">Exibir apenas combinações</span>
    </template>
  </v-switch>
</template>

<script setup>
import {computed} from "vue";
import store from "@/store";

const FLAG_EXIBIR_APENAS_COMBINACOES_COMPUTED = computed({
  get() {
    return store.getters['ProdutosCombinados/exibir_apenas_combinacoes'];
  },
  set(valor) {
    store.dispatch('ProdutosCombinados/exibir_apenas_combinacoes', valor);
  }
});
</script>
